import clsx from "clsx";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import PanelWrapper from "~/components/PanelWrapper";
import useUpdateBlockQuality from "~/entity/Dealer/hooks/useUpdateBlockQuality";
import { DATA_STATUS_TYPES } from "~/constans/statuses";
import { QualityIProps } from "~/entity/Dealer/model/schema";
import { usePermissions } from "~/shared/context/PermissionContext";

import s from "./BlockQuality.less";

interface BlockQualityIProps {
  isLoading: boolean;
  data: QualityIProps[];
  refetch: () => void;
  error?: boolean;
}

const BlockQuality: React.FC<BlockQualityIProps> = ({
  isLoading,
  data,
  refetch,
  error,
}) => {
  const { hasPermission } = usePermissions();
  const { t } = useTranslation();

  const {
    mutateAsync,
    isLoading: mutateLoading,
    isSuccess,
  } = useUpdateBlockQuality();

  useEffect(() => {
    if (!mutateLoading && isSuccess) {
      refetch();
    }
  }, [mutateLoading, isSuccess]);

  return (
    <PanelWrapper
      width={220}
      height={220}
      label={t("dealers.quality")}
      customClassName={s.new_car_padding}
      loading={isLoading}
    >
      <div className={clsx([s.quality_block])}>
        <ul className={s.list}>
          {!error &&
            data &&
            Object.keys(data).map((key: string) => {
              const indicator = data[key];

              return (
                <li key={indicator.name}>
                  <div className={clsx(s.float)}>
                    <span>
                      {`${indicator.name} 
                          ${indicator.quarter}Q${String(indicator.year).slice(
                            2,
                            4,
                          )}:`}
                    </span>
                    <span>
                      {` ${
                        indicator.mark === DATA_STATUS_TYPES.DASH
                          ? DATA_STATUS_TYPES.ND
                          : Math.round(indicator.mark)
                      }`}
                    </span>
                  </div>
                </li>
              );
            })}
        </ul>
      </div>
      <div className={s.quality}>
        {hasPermission("passport.secretShopper.update") && (
          <button className={clsx(s.update)} onClick={() => mutateAsync()}>
            Обновить индикаторы
          </button>
        )}
      </div>
    </PanelWrapper>
  );
};

export default BlockQuality;
